document.addEventListener('DOMContentLoaded', function() {
  // Initialize Swiper for product cards
  const productCardSwipers = document.querySelectorAll('.product-card__swiper');

  if (productCardSwipers.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const swiperElement = entry.target;
          var touchmove = swiperElement.closest('.product-list:not(.product-list--carousel)') !== null;

          new Swiper(swiperElement, {
            effect: 'fade',
            autoHeight: false,
            touchRatio: 1,
            touchAngle: 45,
            allowTouchMove: touchmove,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            pagination: {
              el: ".swiper-pagination",
              type: "progressbar",
            },
            navigation: {
              nextEl: ".card-arrow--next",
              prevEl: ".card-arrow--prev",
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 0
              }
            }
          });

          observer.unobserve(swiperElement);
        }
      });
    }, { rootMargin: "200px" });

    productCardSwipers.forEach(el => observer.observe(el));
  }

  // Desktop scroll animation for product-info__block-group
  function initDesktopScrollAnimation() {
    // Only run on desktop (you can adjust the breakpoint as needed)
    if (window.innerWidth <= 768) return;
    
    const blockGroups = document.querySelectorAll('.product-info__block-group');
    if (blockGroups.length === 0) return;
    
    let isAnimating = false;
    let originalMaxHeights = [];
    let currentState = 'expanded'; // Track current state: 'expanded' or 'collapsed'
    
    // Store original max-height values
    blockGroups.forEach((group, index) => {
      const computedStyle = window.getComputedStyle(group);
      const maxHeight = computedStyle.maxHeight;
      // Convert 'none' to actual pixel value or use a fallback
      if (maxHeight === 'none') {
        // Get the actual height as fallback
        originalMaxHeights[index] = group.offsetHeight + 'px';
      } else {
        originalMaxHeights[index] = maxHeight;
      }
    });
    
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeCollapsed = scrollTop > 300;
      
      // Only animate if state needs to change
      if ((shouldBeCollapsed && currentState === 'expanded') || 
          (!shouldBeCollapsed && currentState === 'collapsed')) {
        
        if (isAnimating) {
          // If already animating, force complete the current animation
          blockGroups.forEach((group, index) => {
            group.style.transition = 'none';
            if (currentState === 'expanded') {
              group.style.maxHeight = '0';
            } else {
              group.style.maxHeight = originalMaxHeights[index];
            }
          });
          
          // Force reflow
          blockGroups[0].offsetHeight;
        }
        
        isAnimating = true;
        currentState = shouldBeCollapsed ? 'collapsed' : 'expanded';
        
        blockGroups.forEach((group, index) => {
          if (shouldBeCollapsed) {
            // Animate to max-height: 0
            group.style.transition = 'max-height 0.3s ease';
            group.style.maxHeight = '0';
            const parent = group.parentElement;
            if (parent) {
              parent.classList.add('on--scroll');
            }
          } else {
            // Restore original max-height
            group.style.transition = 'max-height 0.3s ease';
            group.style.maxHeight = originalMaxHeights[index];
            setTimeout(() => {
              group.style.maxHeight = 'unset';
            }, 500);
            const parent = group.parentElement;
            if (parent) {
              parent.classList.remove('on--scroll');
            }
          }
        });
        
        // Reset animation flag after transition
        setTimeout(() => {
          isAnimating = false;
        }, 300);
      }
    }
    
    // Throttle scroll events for better performance
    let ticking = false;
    function throttledScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Add scroll event listener
    window.addEventListener('scroll', throttledScroll);
    
    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        // Reset to original values on mobile
        blockGroups.forEach((group, index) => {
          group.style.transition = '';
          group.style.maxHeight = originalMaxHeights[index];
          setTimeout(() => {
            group.style.maxHeight = 'unset';
          }, 300);
          const parent = group.parentElement;
          if (parent) {
            parent.classList.remove('on--scroll');
          }
        });
      }
    });
    
    // Initial call to set correct state on page load
    handleScroll();
  }
  
  // Initialize the scroll animation
  // initDesktopScrollAnimation();
});

document.querySelectorAll('.product-info__block-item').forEach(block => {
    const content = block.querySelector('.accordion__content');
    if (!content) return;

    content.querySelectorAll('p').forEach(p => {
        const text = p.textContent.trim();

        if (text === '' || /^[^:]+:\s*$/.test(text)) {
            p.remove();
        }
    });

    if (content.textContent.trim() === '' && content.children.length === 0) {
        block.remove();
    }
});